import { FlaskConical, Users, TrendingUp } from "lucide-react";

const points = [
  {
    icon: FlaskConical,
    text: "Tested across hundreds of practices over two decades",
  },
  {
    icon: Users,
    text: "Refined through real patient data — not theory",
  },
  {
    icon: TrendingUp,
    text: "Focused on what actually produces growth: leads, arrivals, collections",
  },
];

const LandingAuthority = () => {
  return (
    <section className="py-12 md:py-16 bg-background">
      <div className="max-w-3xl mx-auto section-padding text-center">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground tracking-tight mb-3">
          Built From 20+ Years of Real Dental Marketing
        </h2>
        <p className="text-muted-foreground mb-8 max-w-xl mx-auto">
          Not a template. Not guesswork. A scoring system distilled from two decades of growing dental practices — including our own family practice from $1M to $12M.
        </p>
        <div className="grid sm:grid-cols-3 gap-4">
          {points.map((p) => (
            <div key={p.text} className="bg-secondary rounded-xl p-5 border border-border">
              <p.icon className="w-6 h-6 text-accent mx-auto mb-3" />
              <p className="text-sm text-foreground/80 leading-relaxed">{p.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LandingAuthority;
